import { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface AuthContextType {
  user: string | null | undefined;
  isLoading: boolean;
  login: (userData: string) => void;
  logout: () => void;
  emailUsertokenExpired: () => boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<string | null | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = () => {
      const storedUser = localStorage.getItem("auth-user");
      setUser(storedUser);
      setIsLoading(false);
    };

    initializeAuth();
  }, []);

  const login = (userData: string) => {
    setUser(userData);
    localStorage.setItem("auth-user", userData);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("auth-user");
    localStorage.removeItem("staySigned");
  };

  const emailUsertokenExpired = () => {
    if(localStorage.getItem("staySigned")) {
        return false;
    }
    else {
        if(!user) {
            return true;
        }
        else {
            const userString: any = user;
            const profile = JSON.parse(userString);
            const exp = profile.expiresAt;
            const now = new Date();
            const expDate = new Date(exp);
            // console.log("now: " + now)
            // console.log("exp:" + expDate)
            // console.log(now > expDate);
            return now > expDate;
        }
    }
}

  if (isLoading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, emailUsertokenExpired }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};